import React, { useEffect, useState } from 'react';
import './client.css';
import '../tasks/task.css';
import '../shared/companyPicker.css';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, selectUserId, selectUsers, setFromClient, setIsLogOut, setUsers } from '../login/loginSlice';
import ClientMenuModal from './ClientMenuModal';
import { useNavigate } from 'react-router-dom';
import { arrowLIcon, dots3VerticalIcon, addAccountIcon, outIcon, deleteIcon } from '../../static/svgs';
import { createTask } from '../tasks/taskApi';
import DeleteModal from './DeleteModal';
import { getUserData } from '../login/loginApi';
import { url } from '../../static/env';
import CompanyPickerList from '../shared/CompanyPickerList';
import CompanyPaymentBlock from '../shared/CompanyPaymentBlock';
import { applyAccountSwitch, hasMultipleAccounts } from '../../utils/accountUtils';
import { getPacks } from '../documents/packApi';
import { buildBuhBillPaymentSummary } from '../../utils/buhBillPayment';
import { useSectionMenuReset } from '../../context/SectionMenuResetContext';

const Client = ({ setIsLoggedIn }) => {
    const [isModalDeleteAccount, setIsModalDeleteAccount] = useState(false);
    const [companyMenuUser, setCompanyMenuUser] = useState(null);
    const [isHeaderMenuOpen, setIsHeaderMenuOpen] = useState(false);
    const [isSingleDetailMenuOpen, setIsSingleDetailMenuOpen] = useState(false);
    const [deleteTargetUser, setDeleteTargetUser] = useState(null);
    const [client, setClient] = useState({});
    const users = useSelector(selectUsers);
    const current_user = useSelector(selectCurrentUser);
    const user_id = useSelector(selectUserId);
    const multipleAccounts = hasMultipleAccounts(users);
    const [showCompanyDetail, setShowCompanyDetail] = useState(!multipleAccounts);
    const [paymentByUserId, setPaymentByUserId] = useState({});

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setShowCompanyDetail(!hasMultipleAccounts(users));
    }, [users]);

    const handleCompanySelect = (user) => {
        applyAccountSwitch(dispatch, user);
        setShowCompanyDetail(true);
    };

    const handlePaymentClick = (user) => {
        applyAccountSwitch(dispatch, user);
        navigate('/documents', { state: { openBuhBill: true, accountUserId: user.user_id } });
    };

    const handleAddAccount = () => {
        dispatch(setIsLogOut(true));
        dispatch(setFromClient(true));
        navigate('/');
    };

    const logoutUser = (user) => {
        if (!user) return;

        const userData = localStorage.getItem('userList');
        if (!userData) return;

        const parsedUserData = JSON.parse(userData);
        if (parsedUserData.length === 0) return;

        const accountName = user.company_name || user.name || 'аккаунта';
        const confirmation = window.confirm(`Точно выйти из аккаунта ${accountName}?`);
        if (!confirmation) return;

        const updatedUsers = parsedUserData.filter((item) => item.user_id !== user.user_id);
        localStorage.setItem('userList', JSON.stringify(updatedUsers));
        dispatch(setUsers(updatedUsers));

        if (updatedUsers.length === 0) {
            dispatch(setIsLogOut(true));
            navigate('/');
            return;
        }

        if (Number(user.user_id) === Number(user_id)) {
            applyAccountSwitch(dispatch, updatedUsers[0]);
            setShowCompanyDetail(!hasMultipleAccounts(updatedUsers));
        }
    };

    const openDeleteAccount = (user) => {
        setDeleteTargetUser(user);
        setIsModalDeleteAccount(true);
    };

    const deleteCurrentUser = () => {
        const targetId = deleteTargetUser?.user_id || user_id;
        createTask(targetId, 'Удалить аккаунт', 'Удалить аккаунт', {
            timeout: new Date(),
            urgency: 1
        }, (data) => {
            console.log('createTask', data);
        });

        setIsModalDeleteAccount(false);
        setDeleteTargetUser(null);
    };

    useEffect(() => {
        if (!user_id || user_id === 0) {
            navigate('/');
        }
    }, [user_id, navigate]);

    useEffect(() => {
        if (!users?.length) {
            return undefined;
        }

        const loadForList = !showCompanyDetail;
        const loadForDetail = showCompanyDetail;
        if (!loadForList && !loadForDetail) {
            return undefined;
        }

        const targetUsers = loadForList
            ? users
            : users.filter((user) => Number(user.user_id) === Number(user_id));

        if (!targetUsers.length) {
            return undefined;
        }

        let cancelled = false;

        const loadPayments = async () => {
            const entries = await Promise.all(
                targetUsers.map(async (user) => {
                    try {
                        const packs = await getPacks(user.user_id, 'buh_bill');
                        return [user.user_id, buildBuhBillPaymentSummary(packs)];
                    } catch (error) {
                        console.error('Ошибка загрузки счетов:', user.user_id, error);
                        return [user.user_id, buildBuhBillPaymentSummary([])];
                    }
                })
            );

            if (!cancelled) {
                setPaymentByUserId((prev) => ({
                    ...prev,
                    ...Object.fromEntries(entries),
                }));
            }
        };

        loadPayments();

        return () => {
            cancelled = true;
        };
    }, [users, showCompanyDetail, user_id]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const client_data = await getUserData(user_id);
                setClient(client_data.user[0]);
            } catch (error) {
                console.error('Ошибка при получении данных пользователя:', error);
            }
        };

        if (user_id && showCompanyDetail) {
            fetchData();
        }
    }, [user_id, showCompanyDetail]);

    const companyMenuItems = companyMenuUser ? [
        {
            label: 'Выйти',
            icon: outIcon,
            onClick: () => logoutUser(companyMenuUser),
        },
        {
            label: 'Удалить аккаунт',
            icon: deleteIcon,
            danger: true,
            onClick: () => openDeleteAccount(companyMenuUser),
        },
    ] : [];

    const headerMenuItems = [
        {
            label: 'Добавить аккаунт',
            icon: addAccountIcon,
            onClick: handleAddAccount,
        },
    ];

    const singleDetailMenuItems = [
        {
            label: 'Добавить аккаунт',
            icon: addAccountIcon,
            onClick: handleAddAccount,
        },
        {
            label: 'Выйти',
            icon: outIcon,
            onClick: () => logoutUser(users[0] || { user_id, company_name: current_user?.name }),
        },
        {
            label: 'Удалить аккаунт',
            icon: deleteIcon,
            danger: true,
            onClick: () => openDeleteAccount(users[0] || { user_id }),
        },
    ];

    const detailCompanyUser = showCompanyDetail
        ? users?.find((user) => Number(user.user_id) === Number(user_id)) ?? null
        : null;
    const detailCompanyPayment = detailCompanyUser
        ? paymentByUserId[detailCompanyUser.user_id]
        : null;
    const companyDisplayName =
        current_user?.name || current_user?.company_name || client?.name || detailCompanyUser?.company_name || '';

    useSectionMenuReset('/client', () => {
        if (multipleAccounts && showCompanyDetail) {
            setShowCompanyDetail(false);
            return true;
        }
        return false;
    });

    return (
        <div className={`client_cntr client_style client-page${multipleAccounts ? ' client-page--multi' : ''}`}>
            {multipleAccounts ? (
                <>
                    <div className="page_title_cntr client_page_title_row client_page_title_row--companies">
                        <div className="client_page_title_bar">
                            <div className="client_page_title_center">
                                <div
                                    className={`manrope-bold color_white page_title client_companies_heading`}
                                >
                                    Мои компании
                                </div>
                                {!showCompanyDetail && (
                                    <button
                                        type="button"
                                        className="client_title-menu-btn"
                                        aria-label="Меню"
                                        onClick={() => setIsHeaderMenuOpen(true)}
                                    >
                                        {dots3VerticalIcon}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    {showCompanyDetail && (
                        <div className="page_title_cntr client_page_title_row client_page_title_row--detail">
                            <div className="client_page_title_bar">
                                <button
                                    type="button"
                                    className="page-header-nav-back"
                                    onClick={() => setShowCompanyDetail(false)}
                                    aria-label="К списку компаний"
                                >
                                    {arrowLIcon}
                                </button>
                                <div className="manrope-bold color_white section-company-title client_detail_company_name">
                                    {companyDisplayName}
                                </div>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className="page_title_cntr client_page_title_row client_page_title_row--detail">
                    <div className="client_page_title_bar">
                        {showCompanyDetail && (
                            <div className="manrope-bold color_white section-company-title client_detail_company_name">
                                {companyDisplayName}
                            </div>
                        )}
                        {showCompanyDetail && (
                            <button
                                type="button"
                                className="client_title-menu-btn"
                                aria-label="Меню"
                                onClick={() => setIsSingleDetailMenuOpen(true)}
                            >
                                {dots3VerticalIcon}
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div className='client_subcntr'>
                {!showCompanyDetail ? (
                    <CompanyPickerList
                        users={users}
                        onSelect={handleCompanySelect}
                        onMenuClick={setCompanyMenuUser}
                        onPaymentClick={handlePaymentClick}
                        showPaymentInfo
                        paymentByUserId={paymentByUserId}
                    />
                ) : (
                    <>
                        <div className='client_card_cntr manrope-bold'>
                            {detailCompanyUser && (
                                <CompanyPaymentBlock
                                    payment={detailCompanyPayment}
                                    user={detailCompanyUser}
                                    onPaymentClick={handlePaymentClick}
                                />
                            )}
                            <div className='client_row'>
                                <div className='client_row-label color_grey'>Email</div>
                                <div className='client_row-value'>{client?.email}</div>
                            </div>
                            <div className='client_row'>
                                <div className='client_row-label color_grey'>Телефон</div>
                                <div className='client_row-value'>{client?.phone}</div>
                            </div>
                            <div className='client_row'>
                                <div className='client_row-label color_grey'>ИНН</div>
                                <div className='client_row-value'>{client?.inn}</div>
                            </div>
                            <div className='client_row'>
                                <div className='client_row-label color_grey'>Руководитель</div>
                                <div className='client_row-value client_row-value--right'>{client?.ceo}</div>
                            </div>
                            <div className='client_row'>
                                <div className='client_row-label color_grey'>Налогооблажение</div>
                                <div className='client_row-value'>{client?.tax}</div>
                            </div>
                        </div>
                        <div className='client_card2_cntr manrope-bold'>
                            <div className='client_row'>
                                <div style={{ fontSize: 14 }} className='color_white'>Бухгалтер</div>
                                <div style={{ fontSize: 16 }} className='color_white'>{client?.acc_name}</div>
                            </div>
                            <div className='client_row'>
                                <div style={{ fontSize: 14 }} className='color_white'>Email</div>
                                <div className='color_white client_label'>{client?.acc_email}</div>
                            </div>
                            <div className='client_row'>
                                <div style={{ fontSize: 14 }} className='color_white'>Телефон</div>
                                <div style={{ fontSize: 16 }} className='color_white'>{client?.acc_phone}</div>
                            </div>
                            <div className='client_row'>
                                <img className='client_acc_img' alt='' src={`${url}/${client?.acc_path}`} />
                            </div>
                        </div>
                    </>
                )}
            </div>

            {companyMenuUser && (
                <ClientMenuModal
                    onClose={() => setCompanyMenuUser(null)}
                    items={companyMenuItems}
                />
            )}

            {isHeaderMenuOpen && (
                <ClientMenuModal
                    onClose={() => setIsHeaderMenuOpen(false)}
                    items={headerMenuItems}
                />
            )}

            {isSingleDetailMenuOpen && (
                <ClientMenuModal
                    onClose={() => setIsSingleDetailMenuOpen(false)}
                    items={singleDetailMenuItems}
                />
            )}

            {isModalDeleteAccount && (
                <DeleteModal
                    deleteCurrentUser={deleteCurrentUser}
                    onClose={() => {
                        setIsModalDeleteAccount(false);
                        setDeleteTargetUser(null);
                    }}
                />
            )}
        </div>
    );
};

export default Client;
